import React from 'react';
import {
  DialogActions,
  Flex,
  Heading,
  List,
  Paragraph,
  Popover,
  Popper,
  Spacer,
  Tag,
  Text,
  TextButton,
  TriggerButton,
} from '@zillow/constellation';
import InviteToMoveInManager from '../InviteToMoveInManager';
import { formatDate } from '../../ApplicationsTabPage/ListingApplicationsTab/ListingApplications/ListingApplicationsApplicationSection/ListingApplicationsCardList/ListingApplicationCard/ListingApplicationCardUtil';
import { useApplicationSummaryContext } from '../../../contexts/ApplicationSummaryContext';
import { applicationOverallStatusTypes } from '../../../constants/statusConstants';
import { URLS } from '../../../constants/urls';

const PageHeader = () => {
  const { isRentGuaranteeEnabled, landlordRentalApplication, isApplicationDeclined } = useApplicationSummaryContext();
  const { conditionallyApprovedDateTime, declinedDateTime, declinedReasons, isIncomeToRentVerified } =
    landlordRentalApplication;

  const isApplicationConditionallyApproved =
    landlordRentalApplication.overallStatus === applicationOverallStatusTypes.CONDITIONALLY_APPROVED;
  const needsIncomeDocumentVerification = isRentGuaranteeEnabled && !isIncomeToRentVerified;

  return (
    <Spacer marginY="md">
      <Flex
        display="flex"
        justifyContent="space-between"
        alignItems={{ default: 'normal', lg: 'center' }}
        flexDirection={{ default: 'column', lg: 'row' }}
        marginBottom="lg"
      >
        <Heading level={3} as="h1">
          Application overview
        </Heading>
        {!isApplicationDeclined && !needsIncomeDocumentVerification && <InviteToMoveInManager />}
      </Flex>
      {isApplicationDeclined && (
        <>
          <Tag id="page-header__declined-tag" size="md" marginBottom="sm" appearance="error">
            DECLINED
          </Tag>
          <Paragraph marginBottom="md" id="page-header__declined-date">
            {`This application was declined ${formatDate(declinedDateTime)}`}
          </Paragraph>
          <Text>{`Reason(s):`}</Text>
          <List id="page-header__declined-reason-list">
            {declinedReasons.map(({ message }) => (
              <List.Item key={message}>{message}</List.Item>
            ))}
          </List>
        </>
      )}
      {isApplicationConditionallyApproved && (
        <span>
          <Tag appearance="warning" size="md" marginBottom="sm" marginRight="xxs">
            Conditionally approved
          </Tag>
          <Popper
            triggered={
              <Popover
                renderHeader={<Heading level={2}>One last step</Heading>}
                renderBody={
                  <>
                    <Paragraph>
                      Once you’ve completed your review, don’t forget to officially approve or decline this application.
                    </Paragraph>
                    <DialogActions>
                      <TextButton as="a" href={URLS.CONDITIONAL_APPROVAL_URL} target="_blank">
                        Learn more
                      </TextButton>
                    </DialogActions>
                  </>
                }
              />
            }
          >
            <TriggerButton aria-label="conditionally approved learn more" />
          </Popper>
          <Paragraph marginBottom="md" id="page-header__declined-date">
            {`This application was conditionally approved ${formatDate(conditionallyApprovedDateTime)}`}
          </Paragraph>
        </span>
      )}
    </Spacer>
  );
};

export default PageHeader;
